import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 10,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: '8px !important',
    [theme.breakpoints.down('xs')]: {
      marginBottom: 20,
    },
  },
  accordionSummary: {
    flexDirection: 'row-reverse',
  },
  expandMore: {
    alignSelf: 'flex-start',
    marginTop: '12px',
  },
  expanded: {
    minHeight: '30px !important',
  },
  summaryRoot: {
    minHeight: '42px',
  },
  padding: {
    padding: '0 12px',
  },
  summaryContent: {
    margin: '12px 0 !important',
    alignItems: 'center',
    '& .Mui-expanded': {
      margin: '12px 0 !important',
    },
  },
  expandIcon: {
    padding: 0,
    marginRight: 0,
  },
}));

function CustomAccordion({ summary, description, className, iconPosition, id, handleChange, expanded, iconType }) {
  const classes = useStyles();

  const getExpandIcon = () =>
    iconType === 'dropdown' ? (
      <ArrowDropDown style={{ fill: colors.blueChip }} />
    ) : (
      <ExpandMoreIcon style={{ fill: colors.blueChip }} />
    );

  return (
    <Accordion
      classes={{ root: classnames(classes.root, className) }}
      expanded={expanded === id}
      onChange={handleChange(id)}
    >
      <AccordionSummary
        className={iconPosition === 'left' ? classes.accordionSummary : ''}
        expandIcon={getExpandIcon()}
        aria-controls={id}
        id={id}
        classes={{
          expanded: classes.expanded,
          root: classnames(classes.summaryRoot, classes.padding),
          content: classes.summaryContent,
          expandIcon: classnames(classes.expandIcon, iconType !== 'dropdown' && classes.expandMore),
        }}
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails
        classes={{
          root: classnames(classes.detailsRoot, classes.padding),
        }}
      >
        {description}
      </AccordionDetails>
    </Accordion>
  );
}

CustomAccordion.propTypes = {
  summary: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  className: PropTypes.string,
  iconPosition: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleChange: PropTypes.func,
  iconType: PropTypes.string,
};

export default CustomAccordion;
